import cx from 'classnames'

import type { Space } from '@/components/Container'
import { BodyM, HeadingL } from '@/components/Typography'
import type { TitleProps } from '@/models'

import MediaProductGuide, { type MediaProductGuideProps } from './MediaProductGuide'

import { MediaProductGuidesContainer, SectionGuides, SectionSummary } from './styles'

interface MediaProductGuidesBlockProps {
  title?: TitleProps
  subtitle?: TitleProps
  guides: MediaProductGuideProps[] | undefined
  space: Space
}

const MediaProductGuidesBlock = ({
  title,
  subtitle,
  guides,
  space = 'm',
}: MediaProductGuidesBlockProps) => (
  <MediaProductGuidesContainer
    className={cx({
      [`eu-sm-${space}`]: space,
    })}
  >
    {(title || subtitle) && (
      <SectionSummary>
        {title && <HeadingL tag={title.tag || 'h3'}>{title.text}</HeadingL>}
        {subtitle && <BodyM tag={subtitle.tag || 'p'}>{subtitle.text}</BodyM>}
      </SectionSummary>
    )}
    {guides && guides.length > 0 && (
      <SectionGuides>
        {guides.map((guide, index) => (
          <MediaProductGuide key={`mdp-gd-${index}`} {...guide} />
        ))}
      </SectionGuides>
    )}
  </MediaProductGuidesContainer>
)

export default MediaProductGuidesBlock
